const CONFIG = {
  ia_ativa: { label: 'IA ativa',  bg: '#E6F1FB', color: '#185FA5' },
  pendente: { label: 'Pendente',  bg: '#FAEEDA', color: '#854F0B' },
  urgente:  { label: 'Urgente',   bg: '#FDE8E8', color: '#991B1B' },
  agendada: { label: 'Agendada',  bg: '#E1F5EE', color: '#0F6E56' },
};

export default function StatusBadge({ status }) {
  const cfg = CONFIG[status] ?? { label: status, bg: '#F1F3F5', color: '#6C757D' };

  return (
    <span style={{
      backgroundColor: cfg.bg,
      color: cfg.color,
      borderRadius: '99px',
      fontSize: '11px',
      fontWeight: 500,
      padding: '2px 8px',
      whiteSpace: 'nowrap',
      display: 'inline-block',
    }}>
      {cfg.label}
    </span>
  );
}
